module.exports = __webpack_public_path__ + "media/images/pic/teachers/katarzyna-stanko-b2ae4f7660fbe5eb25945be29ea20549.png";